module.exports = __webpack_public_path__ + "media/homepage_video.asset.394e30eb.webm";